@if (isLive) {
  <div class="live-stats">
    <button
      type="button"
      class="live-stat"
      (click)="open('Gana ' + match.homeTeam.name, match.stats?.homeWinUsers)"
    >
      <span class="live-stat-val">{{ match.stats?.homeWin }}</span>
      <span class="live-stat-lbl">1</span>
    </button>
    <button
      type="button"
      class="live-stat"
      (click)="open('Empate', match.stats?.drawUsers)"
    >
      <span class="live-stat-val">{{ match.stats?.draw }}</span>
      <span class="live-stat-lbl">X</span>
    </button>
    <button
      type="button"
      class="live-stat"
      (click)="open('Gana ' + match.awayTeam.name, match.stats?.awayWinUsers)"
    >
      <span class="live-stat-val">{{ match.stats?.awayWin }}</span>
      <span class="live-stat-lbl">2</span>
    </button>
    <button
      type="button"
      class="live-stat live-stat--joker"
      (click)="open('Usan comodín', match.stats?.jokersUsers)"
    >
      <span class="live-stat-val">{{ match.stats?.jokers }}</span>
      <img src="/assets/imgs/joker-on.svg" />
    </button>
  </div>
  @if (scoreResults.length > 0) {
    <div class="live-score-results">
      @for (scoreResult of scoreResults; track scoreResult.label + '-' + $index) {
        <button
          type="button"
          class="live-score-result"
          (click)="open('Han puesto ' + scoreResult.label, scoreResult.users)"
        >
          <span class="score-result-label-inline">
            {{ scoreResult.label }}
            @if (scoreResult.winnerTeam?.flag) {
              <img
                class="score-result-flag"
                [src]="scoreResult.winnerTeam.flag"
                [alt]="scoreResult.winnerTeam.name"
              />
            }
          </span>
          <strong>{{ scoreResult.count }}</strong>
        </button>
      }
    </div>
  }
} @else {
  <div class="match-stats-section">
    <button type="button" class="stats-toggle" (click)="toggle()">
      <mat-icon [class.rotated]="expanded">expand_more</mat-icon>
      <span>Estadísticas del partido</span>
    </button>

    @if (expanded) {
      <div class="match-stats-row">
        <button
          type="button"
          class="stat-pill"
          (click)="open('Han puesto 1 · ' + match.homeTeam?.name, match.stats?.homeWinUsers)"
        >
          <span class="stat-val">{{ match.stats?.homeWin }}</span>
          <span class="stat-lbl">1</span>
        </button>
        <button
          type="button"
          class="stat-pill"
          (click)="open('Han puesto X · Empate', match.stats?.drawUsers)"
        >
          <span class="stat-val">{{ match.stats?.draw }}</span>
          <span class="stat-lbl">X</span>
        </button>
        <button
          type="button"
          class="stat-pill"
          (click)="open('Han puesto 2 · ' + match.awayTeam?.name, match.stats?.awayWinUsers)"
        >
          <span class="stat-val">{{ match.stats?.awayWin }}</span>
          <span class="stat-lbl">2</span>
        </button>
        <button
          type="button"
          class="stat-pill stat-pill--joker"
          (click)="open('Han usado joker', match.stats?.jokersUsers)"
        >
          <span class="stat-val">{{ match.stats?.jokers }}</span>
          <img src="/assets/imgs/joker-on.svg" />
        </button>
      </div>

      @if (scoreResults.length > 0) {
        <div class="score-results-grid">
          @for (scoreResult of scoreResults; track scoreResult.label + '-' + $index) {
            <button
              type="button"
              class="score-result-pill"
              (click)="open('Han puesto ' + scoreResult.label, scoreResult.users)"
            >
              <span class="score-result-label">
                {{ scoreResult.label }}
                @if (scoreResult.winnerTeam?.flag) {
                  <img
                    class="score-result-flag"
                    [src]="scoreResult.winnerTeam.flag"
                    [alt]="scoreResult.winnerTeam.name"
                  />
                }
              </span>
              <span class="score-result-count">{{ scoreResult.count }}</span>
            </button>
          }
        </div>
      }
    }
  </div>
}
